import moment from 'moment';
import { formatIsoDate, formatIsoDateTime } from 'utils/dates';
import Base from 'app/models/base';

export const DATERANGE_PARAM_TYPES = {
  DATETIME: 0,
  DATE: 1,
};

export default Base.extend({
  /* paramKeys should be an object with keys of `startKey` and `endKey` */
  initialize({
    startDatetime, endDatetime, paramType = DATERANGE_PARAM_TYPES.DATETIME, paramKeys = {},
  }) {
    this.paramType = paramType;
    this.paramKeys = paramKeys;
    if (!(this.paramKeys.startKey || this.paramKeys.endKey)) {
      if (this.paramType === DATERANGE_PARAM_TYPES.DATETIME) {
        this.paramKeys = { startKey: 'start_datetime', endKey: 'end_datetime' };
      } else if (this.paramType === DATERANGE_PARAM_TYPES.DATE) {
        this.paramKeys = { startKey: 'start_date', endKey: 'end_date' };
      } else {
        throw new Error('Invalid paramType');
      }
    }

    this.setCurrentChoice({
      [this.paramKeys.startKey]: startDatetime || moment.utc().subtract(1, 'months').add(1, 'days').startOf('day'),
      [this.paramKeys.endKey]: endDatetime || moment.utc().startOf('day'),
    });
  },

  // rename this, and put it in a base class named: Filter? Selection?
  setCurrentChoice(o) {
    let startDateTime = o[this.paramKeys.startKey];
    let endDateTime = o[this.paramKeys.endKey];
    if (startDateTime && endDateTime) {
      if (!(startDateTime instanceof moment)) startDateTime = moment(startDateTime).utc();
      if (!(endDateTime instanceof moment)) endDateTime = moment(endDateTime).utc();
      this.set('startDatetime', startDateTime);
      this.set('endDatetime', endDateTime);
    }
  },

  getStartDatetimeForParam() {
    return moment(this.get('startDatetime')).utc().startOf('day');
  },

  getEndDatetimeForParam() {
    return moment(this.get('endDatetime')).utc().endOf('day');
  },

  getDayAfterEndDatetimeForParam() {
    return moment(this.get('endDatetime')).utc().add(1, 'days').endOf('day');
  },

  getParams() {
    const {
      startKey,
      endKey,
    } = this.paramKeys;

    if (this.paramType === DATERANGE_PARAM_TYPES.DATETIME) {
      return {
        [startKey]: formatIsoDateTime(this.getStartDatetimeForParam()),
        [endKey]: formatIsoDateTime(this.getEndDatetimeForParam()),
      };
    }
    return {
      [startKey]: formatIsoDate(this.getStartDatetimeForParam()),
      [endKey]: formatIsoDate(this.getEndDatetimeForParam()),
    };
  },

  daysBetweenDates() {
    return Math.ceil(this.get('endDatetime').utc().diff(this.get('startDatetime').utc(), 'days', true));
  },
});



// WEBPACK FOOTER //
// ./app/models/date_range.js